module.exports = require("@material-ui/core/colors/amber");